<script setup lang="ts">
const { $containment, $kyc } = useNuxtApp();

async function onValidateButtonClick() {
  $kyc.setSource('password_recovery_attempt_limit');

  await $containment.handle(
    [
      {
        name: 'kyc',
        frequent: true,
      },
    ],
    () => {
      const { openModal } = useLayoutStore();

      openModal('recovery-password-options');

      const { setRecoveryPasswordData } = useAuthStore();

      setRecoveryPasswordData({
        kyc_id: null,
      });
    },
  );
}
</script>

<template>
  <div :class="$style.attemptLimit">
    <img
      alt="Alert icon"
      aria-hidden="true"
      :class="$style.icon"
      :src="getAssetsUrlForCDN('/assets/images/alert.png')"
    />

    <div :class="$style.textMessage">
      <p>{{ $t('auth.recover_access.title') }} </p>
      <span> {{ $t('auth.recover_access.description') }} </span>
    </div>

    <button
      :class="$style.btnSubmit"
      type="button"
      @click="onValidateButtonClick"
    >
      <span>{{ $t('auth.recover_access.continue') }}</span>
    </button>
    <!-- <BaseKycButton :content-class="$style.btnSubmit">
      <span>{{ $t('auth.recover_access.continue') }}</span>
    </BaseKycButton> -->
  </div>
</template>

<style module lang="postcss">
.attemptLimit {
  @apply flex flex-col justify-center items-center space-y-6 my-4;

  .textMessage {
    @apply mt-8 text-center justify-center items-center;

    p {
      @apply text-texts font-semibold mb-4;
    }
    span {
      @apply text-texts text-sm;
    }
  }

  .icon {
    @apply w-28 h-28 mx-auto mt-5;
  }

  .btnSubmit {
    @apply bg-button-bg text-button-text py-2 px-4 rounded-md text-sm font-semibold whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed;
  }
}
</style>
